module.exports = "https://dev.stanwinstonschool.com/indianajones.5e56a213cb1e06264468a5f0e1fb8cba.jpg";